import React from "react";

const Contact = () => {
  return (
    <div className=" -mt-16 ">
      <div className="bg-red-500  w-full h-[100px] flex justify-evenly items-center">
        <h1 className="text-white text-2xl ">
          <span className=" ">
            Contact us now to get quote for all your global shipping needs.
          </span>
        </h1>
        <h1 className="text-white text-xl ">
          <span className="border-2 rounded-md py-1 hover:bg-white hover:text-black cursor-pointer">
            <span className=" p-7 ">CONTACT US</span>
          </span>
        </h1>
      </div>
    </div>
  );
};

export default Contact;
